import { Inject, Injectable } from '@angular/core';
import { UtilityPacimService } from './utilities.service';
import { API_BASE_PACIM_URL, PacimUtilityEntity } from '../index';
import { HandleError, HttpUtility, PacimHttpErrorHandlerService } from '@core/http';

@Injectable({
  providedIn: 'root'
})
export class AdditionalFacilityUtilityService extends UtilityPacimService {
  entityType = PacimUtilityEntity.AdditionalFacility;

  handleError: HandleError;

  constructor(
    httpUtility: HttpUtility,
    @Inject(API_BASE_PACIM_URL) apiBaseUrl: string,
    pacimHttpErrorHandler: PacimHttpErrorHandlerService
  ) {
    super(httpUtility, apiBaseUrl);
    this.handleError = pacimHttpErrorHandler.createHandleError('AdditionalFacilityUtilityService');
  }
}
